var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVzyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 44,
    viewBox: "0 0 84 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5442 0.211942C42.0683 0.61934 41.7951 1.36064 41.5219 1.90224C41.4005 2.14509 41.18 2.50455 41.0825 2.69787C40.7886 3.25544 40.5106 3.83379 40.231 4.40734C39.9674 4.93456 39.7022 5.45859 39.4513 5.9938C39.2229 6.52102 38.8283 7.15688 38.162 6.91244C37.3792 6.54658 37.5949 5.16302 37.531 4.42811C37.4511 3.49828 36.6746 2.89278 35.9621 2.48219C35.3694 2.14029 34.8469 1.97893 34.5482 1.3255C34.39 0.962833 34.5082 0.475553 34.831 0.258274C35.0898 0.080936 35.4093 0.0362021 35.9174 0.0186281C37.1284 -0.0245081 38.7388 0.0186279 39.9226 0.0346042C40.8892 0.0473853 41.2231 0.00265244 41.541 0.210345L41.5458 0.21354L41.5442 0.211942Z",
    fill: "#FEC00F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3876 16.1962C20.3077 16.1803 20.1383 16.1339 19.9786 15.9949C19.8444 15.8783 19.7789 15.7489 19.7469 15.6754L12.9681 1.24394C12.6486 0.563345 11.8354 0.00576928 11.1628 0.00576928H0.89157C0.10713 0.0361244 -0.223581 0.695949 0.159852 1.50116L15.2 33.1296C15.5132 33.7894 16.3104 34.3294 16.9686 34.3294H24.7795C25.4393 34.3294 26.2349 33.7894 26.548 33.1296L38.8946 7.32455C38.885 7.31656 38.877 7.30857 38.8674 7.30058C38.8642 7.29739 38.8642 7.29739 38.8642 7.29739C38.8642 7.29739 38.8642 7.29739 38.861 7.29419C38.8547 7.2894 38.8499 7.28621 38.8435 7.28141C38.8403 7.27822 38.8355 7.27662 38.8323 7.27342C38.5974 7.54023 37.9648 7.53384 37.5622 7.38526C36.7362 6.99544 36.9631 5.51602 36.896 4.73158C36.8113 3.73785 35.9933 3.09081 35.2392 2.65306C34.6129 2.2872 34.0617 2.11465 33.747 1.41648C33.5808 1.02826 33.7055 0.509026 34.0458 0.275771C34.1688 0.191096 34.3078 0.135178 34.4691 0.0984326V0.000976562L33.8572 0.00576928H29.8552C29.2065 0.0345268 28.4476 0.561748 28.1425 1.2024C25.9377 5.89946 23.7346 10.5965 21.5299 15.292C21.5171 15.3607 21.418 15.8511 20.9643 16.086C20.7263 16.2106 20.4962 16.2074 20.386 16.1978L20.3876 16.1962Z",
    fill: "#FEC00F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2466_23735",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 35
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3876 16.1962C20.3077 16.1803 20.1383 16.1339 19.9786 15.9949C19.8444 15.8783 19.7789 15.7489 19.7469 15.6754L12.9681 1.24394C12.6486 0.563345 11.8354 0.00576928 11.1628 0.00576928H0.89157C0.10713 0.0361244 -0.223581 0.695949 0.159852 1.50116L15.2 33.1296C15.5132 33.7894 16.3104 34.3294 16.9686 34.3294H24.7795C25.4393 34.3294 26.2349 33.7894 26.548 33.1296L38.8946 7.32455C38.885 7.31656 38.877 7.30857 38.8674 7.30058C38.8642 7.29739 38.8642 7.29739 38.8642 7.29739C38.8642 7.29739 38.8642 7.29739 38.861 7.29419C38.8547 7.2894 38.8499 7.28621 38.8435 7.28141C38.8403 7.27822 38.8355 7.27662 38.8323 7.27342C38.5974 7.54023 37.9648 7.53384 37.5622 7.38526C36.7362 6.99544 36.9631 5.51602 36.896 4.73158C36.8113 3.73785 35.9933 3.09081 35.2392 2.65306C34.6129 2.2872 34.0617 2.11465 33.747 1.41648C33.5808 1.02826 33.7055 0.509026 34.0458 0.275771C34.1688 0.191096 34.3078 0.135178 34.4691 0.0984326V0.000976562L33.8572 0.00576928H29.8552C29.2065 0.0345268 28.4476 0.561748 28.1425 1.2024C25.9377 5.89946 23.7346 10.5965 21.5299 15.292C21.5171 15.3607 21.418 15.8511 20.9643 16.086C20.7263 16.2106 20.4962 16.2074 20.386 16.1978L20.3876 16.1962Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2466_23735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0500367 -0.000732422H-0.0839844V34.3277H0.0500367V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.184802 -0.000732422H0.0507812V34.3277H0.184802V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.319568 -0.000732422H0.185547V34.3277H0.319568V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.452383 -0.000732422H0.318359V34.3277H0.452383V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.585193 -0.000732422H0.451172V34.3277H0.585193V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.719961 -0.000732422H0.585938V34.3277H0.719961V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.854724 -0.000732422H0.720703V34.3277H0.854724V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.987537 -0.000732422H0.853516V34.3277H0.987537V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12035 -0.000732422H0.986328V34.3277H1.12035V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25511 -0.000732422H1.12109V34.3277H1.25511V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38988 -0.000732422H1.25586V34.3277H1.38988V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52269 -0.000732422H1.38867V34.3277H1.52269V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65551 -0.000732422H1.52148V34.3277H1.65551V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79027 -0.000732422H1.65625V34.3277H1.79027V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92504 -0.000732422H1.79102V34.3277H1.92504V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.05785 -0.000732422H1.92383V34.3277H2.05785V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.19066 -0.000732422H2.05664V34.3277H2.19066V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32543 -0.000732422H2.19141V34.3277H2.32543V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4602 -0.000732422H2.32617V34.3277H2.4602V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.59301 -0.000732422H2.45898V34.3277H2.59301V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72582 -0.000732422H2.5918V34.3277H2.72582V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.86058 -0.000732422H2.72656V34.3277H2.86058V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99535 -0.000732422H2.86133V34.3277H2.99535V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13012 -0.000732422H2.99609V34.3277H3.13012V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26293 -0.000732422H3.12891V34.3277H3.26293V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39574 -0.000732422H3.26172V34.3277H3.39574V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53051 -0.000732422H3.39648V34.3277H3.53051V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66332 -0.000732422H3.5293V34.3277H3.66332V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79613 -0.000732422H3.66211V34.3277H3.79613V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9309 -0.000732422H3.79688V34.3277H3.9309V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06566 -0.000732422H3.93164V34.3277H4.06566V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20043 -0.000732422H4.06641V34.3277H4.20043V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33129 -0.000732422H4.19727V34.3277H4.33129V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46605 -0.000732422H4.33203V34.3277H4.46605V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60082 -0.000732422H4.4668V34.3277H4.60082V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73558 -0.000732422H4.60156V34.3277H4.73558V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8684 -0.000732422H4.73438V34.3277H4.8684V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00121 -0.000732422H4.86719V34.3277H5.00121V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13598 -0.000732422H5.00195V34.3277H5.13598V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26879 -0.000732422H5.13477V34.3277H5.26879V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4016 -0.000732422H5.26758V34.3277H5.4016V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53636 -0.000732422H5.40234V34.3277H5.53636V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67113 -0.000732422H5.53711V34.3277H5.67113V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8059 -0.000732422H5.67188V34.3277H5.8059V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93871 -0.000732422H5.80469V34.3277H5.93871V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07152 -0.000732422H5.9375V34.3277H6.07152V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20629 -0.000732422H6.07227V34.3277H6.20629V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34105 -0.000732422H6.20703V34.3277H6.34105V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47386 -0.000732422H6.33984V34.3277H6.47386V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60668 -0.000732422H6.47266V34.3277H6.60668V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74145 -0.000732422H6.60742V34.3277H6.74145V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87426 -0.000732422H6.74023V34.3277H6.87426V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00707 -0.000732422H6.87305V34.3277H7.00707V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14183 -0.000732422H7.00781V34.3277H7.14183V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2766 -0.000732422H7.14258V34.3277H7.2766V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40941 -0.000732422H7.27539V34.3277H7.40941V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54418 -0.000732422H7.41016V34.3277H7.54418V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67699 -0.000732422H7.54297V34.3277H7.67699V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81176 -0.000732422H7.67773V34.3277H7.81176V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94457 -0.000732422H7.81055V34.3277H7.94457V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07933 -0.000732422H7.94531V34.3277H8.07933V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2141 -0.000732422H8.08008V34.3277H8.2141V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34691 -0.000732422H8.21289V34.3277H8.34691V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47972 -0.000732422H8.3457V34.3277H8.47972V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61449 -0.000732422H8.48047V34.3277H8.61449V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7473 -0.000732422H8.61328V34.3277H8.7473V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88207 -0.000732422H8.74805V34.3277H8.88207V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01488 -0.000732422H8.88086V34.3277H9.01488V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14965 -0.000732422H9.01562V34.3277H9.14965V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28246 -0.000732422H9.14844V34.3277H9.28246V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41723 -0.000732422H9.2832V34.3277H9.41723V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55004 -0.000732422H9.41602V34.3277H9.55004V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6848 -0.000732422H9.55078V34.3277H9.6848V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81761 -0.000732422H9.68359V34.3277H9.81761V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95238 -0.000732422H9.81836V34.3277H9.95238V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0852 -0.000732422H9.95117V34.3277H10.0852V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.22 -0.000732422H10.0859V34.3277H10.22V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3528 -0.000732422H10.2188V34.3277H10.3528V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4875 -0.000732422H10.3535V34.3277H10.4875V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6204 -0.000732422H10.4863V34.3277H10.6204V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7551 -0.000732422H10.6211V34.3277H10.7551V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8899 -0.000732422H10.7559V34.3277H10.8899V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0227 -0.000732422H10.8887V34.3277H11.0227V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1555 -0.000732422H11.0215V34.3277H11.1555V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2903 -0.000732422H11.1562V34.3277H11.2903V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4231 -0.000732422H11.2891V34.3277H11.4231V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5578 -0.000732422H11.4238V34.3277H11.5578V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6907 -0.000732422H11.5566V34.3277H11.6907V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8254 -0.000732422H11.6914V34.3277H11.8254V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9582 -0.000732422H11.8242V34.3277H11.9582V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.093 -0.000732422H11.959V34.3277H12.093V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2258 -0.000732422H12.0918V34.3277H12.2258V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3606 -0.000732422H12.2266V34.3277H12.3606V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4953 -0.000732422H12.3613V34.3277H12.4953V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6282 -0.000732422H12.4941V34.3277H12.6282V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.761 -0.000732422H12.627V34.3277H12.761V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8957 -0.000732422H12.7617V34.3277H12.8957V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0286 -0.000732422H12.8945V34.3277H13.0286V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1633 -0.000732422H13.0293V34.3277H13.1633V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2961 -0.000732422H13.1621V34.3277H13.2961V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4309 -0.000732422H13.2969V34.3277H13.4309V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5657 -0.000732422H13.4316V34.3277H13.5657V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6985 -0.000732422H13.5645V34.3277H13.6985V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8313 -0.000732422H13.6973V34.3277H13.8313V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9661 -0.000732422H13.832V34.3277H13.9661V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1008 -0.000732422H13.9668V34.3277H14.1008V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2336 -0.000732422H14.0996V34.3277H14.2336V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3664 -0.000732422H14.2324V34.3277H14.3664V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5012 -0.000732422H14.3672V34.3277H14.5012V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.634 -0.000732422H14.5V34.3277H14.634V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7668 -0.000732422H14.6328V34.3277H14.7668V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9016 -0.000732422H14.7676V34.3277H14.9016V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0364 -0.000732422H14.9023V34.3277H15.0364V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1711 -0.000732422H15.0371V34.3277H15.1711V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3039 -0.000732422H15.1699V34.3277H15.3039V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4368 -0.000732422H15.3027V34.3277H15.4368V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5715 -0.000732422H15.4375V34.3277H15.5715V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7063 -0.000732422H15.5723V34.3277H15.7063V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8391 -0.000732422H15.7051V34.3277H15.8391V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9739 -0.000732422H15.8398V34.3277H15.9739V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1067 -0.000732422H15.9727V34.3277H16.1067V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2414 -0.000732422H16.1074V34.3277H16.2414V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3743 -0.000732422H16.2402V34.3277H16.3743V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5071 -0.000732422H16.373V34.3277H16.5071V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6418 -0.000732422H16.5078V34.3277H16.6418V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7766 -0.000732422H16.6426V34.3277H16.7766V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9094 -0.000732422H16.7754V34.3277H16.9094V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0422 -0.000732422H16.9082V34.3277H17.0422V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.177 -0.000732422H17.043V34.3277H17.177V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3118 -0.000732422H17.1777V34.3277H17.3118V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4446 -0.000732422H17.3105V34.3277H17.4446V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5774 -0.000732422H17.4434V34.3277H17.5774V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7121 -0.000732422H17.5781V34.3277H17.7121V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8469 -0.000732422H17.7129V34.3277H17.8469V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9797 -0.000732422H17.8457V34.3277H17.9797V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1125 -0.000732422H17.9785V34.3277H18.1125V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2473 -0.000732422H18.1133V34.3277H18.2473V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3821 -0.000732422H18.248V34.3277H18.3821V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5149 -0.000732422H18.3809V34.3277H18.5149V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6496 -0.000732422H18.5156V34.3277H18.6496V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7825 -0.000732422H18.6484V34.3277H18.7825V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9462 -0.000732422H18.7832V34.3277H18.9462V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1083 -0.000732422H18.9453V34.3277H19.1083V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2723 -0.000732422H19.1094V34.3277H19.2723V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4344 -0.000732422H19.2715V34.3277H19.4344V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5985 -0.000732422H19.4355V34.3277H19.5985V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7626 -0.000732422H19.5996V34.3277H19.7626V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9247 -0.000732422H19.7617V34.3277H19.9247V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0887 -0.000732422H19.9258V34.3277H20.0887V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2509 -0.000732422H20.0879V34.3277H20.2509V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.413 -0.000732422H20.25V34.3277H20.413V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.579 -0.000732422H20.416V34.3277H20.579V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7411 -0.000732422H20.5781V34.3277H20.7411V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9051 -0.000732422H20.7422V34.3277H20.9051V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0673 -0.000732422H20.9043V34.3277H21.0673V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2294 -0.000732422H21.0664V34.3277H21.2294V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3954 -0.000732422H21.2324V34.3277H21.3954V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5575 -0.000732422H21.3945V34.3277H21.5575V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7216 -0.000732422H21.5586V34.3277H21.7216V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8837 -0.000732422H21.7207V34.3277H21.8837V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0477 -0.000732422H21.8848V34.3277H22.0477V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2118 -0.000732422H22.0488V34.3277H22.2118V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3739 -0.000732422H22.2109V34.3277H22.3739V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.538 -0.000732422H22.375V34.3277H22.538V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7001 -0.000732422H22.5371V34.3277H22.7001V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8641 -0.000732422H22.7012V34.3277H22.8641V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0282 -0.000732422H22.8652V34.3277H23.0282V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1903 -0.000732422H23.0273V34.3277H23.1903V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3544 -0.000732422H23.1914V34.3277H23.3544V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5165 -0.000732422H23.3535V34.3277H23.5165V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6805 -0.000732422H23.5176V34.3277H23.6805V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8446 -0.000732422H23.6816V34.3277H23.8446V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0067 -0.000732422H23.8438V34.3277H24.0067V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1708 -0.000732422H24.0078V34.3277H24.1708V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3329 -0.000732422H24.1699V34.3277H24.3329V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4969 -0.000732422H24.334V34.3277H24.4969V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.661 -0.000732422H24.498V34.3277H24.661V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8231 -0.000732422H24.6602V34.3277H24.8231V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9872 -0.000732422H24.8242V34.3277H24.9872V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1493 -0.000732422H24.9863V34.3277H25.1493V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3134 -0.000732422H25.1504V34.3277H25.3134V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4774 -0.000732422H25.3145V34.3277H25.4774V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6395 -0.000732422H25.4766V34.3277H25.6395V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8036 -0.000732422H25.6406V34.3277H25.8036V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9657 -0.000732422H25.8027V34.3277H25.9657V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1298 -0.000732422H25.9668V34.3277H26.1298V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2938 -0.000732422H26.1309V34.3277H26.2938V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4559 -0.000732422H26.293V34.3277H26.4559V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.62 -0.000732422H26.457V34.3277H26.62V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7821 -0.000732422H26.6191V34.3277H26.7821V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9462 -0.000732422H26.7832V34.3277H26.9462V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1102 -0.000732422H26.9473V34.3277H27.1102V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2723 -0.000732422H27.1094V34.3277H27.2723V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4364 -0.000732422H27.2734V34.3277H27.4364V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5985 -0.000732422H27.4355V34.3277H27.5985V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7626 -0.000732422H27.5996V34.3277H27.7626V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9266 -0.000732422H27.7637V34.3277H27.9266V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0887 -0.000732422H27.9258V34.3277H28.0887V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2528 -0.000732422H28.0898V34.3277H28.2528V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4169 -0.000732422H28.2539V34.3277H28.4169V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5809 -0.000732422H28.418V34.3277H28.5809V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.743 -0.000732422H28.5801V34.3277H28.743V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9051 -0.000732422H28.7422V34.3277H28.9051V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0673 -0.000732422H28.9043V34.3277H29.0673V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2333 -0.000732422H29.0703V34.3277H29.2333V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3973 -0.000732422H29.2344V34.3277H29.3973V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5594 -0.000732422H29.3965V34.3277H29.5594V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7216 -0.000732422H29.5586V34.3277H29.7216V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8856 -0.000732422H29.7227V34.3277H29.8856V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0497 -0.000732422H29.8867V34.3277H30.0497V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2137 -0.000732422H30.0508V34.3277H30.2137V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3758 -0.000732422H30.2129V34.3277H30.3758V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.538 -0.000732422H30.375V34.3277H30.538V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.702 -0.000732422H30.5391V34.3277H30.702V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8661 -0.000732422H30.7031V34.3277H30.8661V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0282 -0.000732422H30.8652V34.3277H31.0282V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1923 -0.000732422H31.0293V34.3277H31.1923V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5317 -0.000732422H31.1914V34.3277H31.5317V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8735 -0.000732422H31.5332V34.3277H31.8735V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2133 -0.000732422H31.873V34.3277H32.2133V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5532 -0.000732422H32.2129V34.3277H32.5532V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.893 -0.000732422H32.5527V34.3277H32.893V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2329 -0.000732422H32.8926V34.3277H33.2329V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5727 -0.000732422H33.2324V34.3277H33.5727V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9126 -0.000732422H33.5723V34.3277H33.9126V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2524 -0.000732422H33.9121V34.3277H34.2524V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5942 -0.000732422H34.2539V34.3277H34.5942V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.934 -0.000732422H34.5938V34.3277H34.934V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2739 -0.000732422H34.9336V34.3277H35.2739V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6137 -0.000732422H35.2734V34.3277H35.6137V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9536 -0.000732422H35.6133V34.3277H35.9536V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2934 -0.000732422H35.9531V34.3277H36.2934V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6333 -0.000732422H36.293V34.3277H36.6333V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9731 -0.000732422H36.6328V34.3277H36.9731V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3149 -0.000732422H36.9746V34.3277H37.3149V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6548 -0.000732422H37.3145V34.3277H37.6548V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9946 -0.000732422H37.6543V34.3277H37.9946V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3344 -0.000732422H37.9941V34.3277H38.3344V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6743 -0.000732422H38.334V34.3277H38.6743V-0.000732422Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8959 -0.000732422H38.6738V34.3277H38.8959V-0.000732422Z",
    fill: "#FEC00F"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4975 9.60278H74.9342C74.4582 9.60278 73.8846 9.99101 73.6593 10.4671L70.9689 16.1259C70.8411 16.3704 70.643 16.4998 70.373 16.5126C70.1222 16.5078 69.9049 16.3975 69.7771 16.1291L67.0851 10.4687C66.8582 9.99261 66.2846 9.60438 65.8101 9.60438H58.2469C57.6526 9.60438 57.397 10.0901 57.6798 10.6844L65.9619 26.6704C66.0642 26.8956 66.1217 27.1273 66.1345 27.3637C66.16 27.6066 66.0817 27.8286 65.9619 28.0827L60.0523 42.9167C59.7695 43.5111 60.0251 43.9999 60.6194 43.9999H67.502C67.9781 43.9999 68.5517 43.6101 68.7786 43.1356L83.0662 10.6844C83.349 10.0901 83.0934 9.60438 82.4991 9.60438L82.4975 9.60278Z",
    fill: "#FEC00F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2466_23735",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 9,
    width: 27,
    height: 35
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4975 9.60278H74.9342C74.4582 9.60278 73.8846 9.99101 73.6593 10.4671L70.9689 16.1259C70.8411 16.3704 70.643 16.4998 70.373 16.5126C70.1222 16.5078 69.9049 16.3975 69.7771 16.1291L67.0851 10.4687C66.8582 9.99261 66.2846 9.60438 65.8101 9.60438H58.2469C57.6526 9.60438 57.397 10.0901 57.6798 10.6844L65.9619 26.6704C66.0642 26.8956 66.1217 27.1273 66.1345 27.3637C66.16 27.6066 66.0817 27.8286 65.9619 28.0827L60.0523 42.9167C59.7695 43.5111 60.0251 43.9999 60.6194 43.9999H67.502C67.9781 43.9999 68.5517 43.6101 68.7786 43.1356L83.0662 10.6844C83.349 10.0901 83.0934 9.60438 82.4991 9.60438L82.4975 9.60278Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2466_23735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7607 9.60278H57.3965V43.9999H57.7607V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8686 9.60278H57.7617V43.9999H57.8686V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9741 9.60278H57.8672V43.9999H57.9741V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0796 9.60278H57.9727V43.9999H58.0796V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.185 9.60278H58.0781V43.9999H58.185V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2924 9.60278H58.1855V43.9999H58.2924V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3979 9.60278H58.291V43.9999H58.3979V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5053 9.60278H58.3984V43.9999H58.5053V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6128 9.60278H58.5059V43.9999H58.6128V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7182 9.60278H58.6113V43.9999H58.7182V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8237 9.60278H58.7168V43.9999H58.8237V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9292 9.60278H58.8223V43.9999H58.9292V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0385 9.60278H58.9316V43.9999H59.0385V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.144 9.60278H59.0371V43.9999H59.144V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2495 9.60278H59.1426V43.9999H59.2495V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.355 9.60278H59.248V43.9999H59.355V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4624 9.60278H59.3555V43.9999H59.4624V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5678 9.60278H59.4609V43.9999H59.5678V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6753 9.60278H59.5684V43.9999H59.6753V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7807 9.60278H59.6738V43.9999H59.7807V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8881 9.60278H59.7812V43.9999H59.8881V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9936 9.60278H59.8867V43.9999H59.9936V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0991 9.60278H59.9922V43.9999H60.0991V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2046 9.60278H60.0977V43.9999H60.2046V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.312 9.60278H60.2051V43.9999H60.312V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4174 9.60278H60.3105V43.9999H60.4174V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5249 9.60278H60.418V43.9999H60.5249V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6303 9.60278H60.5234V43.9999H60.6303V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7378 9.60278H60.6309V43.9999H60.7378V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8432 9.60278H60.7363V43.9999H60.8432V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9487 9.60278H60.8418V43.9999H60.9487V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0542 9.60278H60.9473V43.9999H61.0542V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1616 9.60278H61.0547V43.9999H61.1616V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2671 9.60278H61.1602V43.9999H61.2671V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3745 9.60278H61.2676V43.9999H61.3745V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4799 9.60278H61.373V43.9999H61.4799V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5874 9.60278H61.4805V43.9999H61.5874V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6928 9.60278H61.5859V43.9999H61.6928V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8003 9.60278H61.6934V43.9999H61.8003V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9057 9.60278H61.7988V43.9999H61.9057V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0112 9.60278H61.9043V43.9999H62.0112V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1186 9.60278H62.0117V43.9999H62.1186V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2241 9.60278H62.1172V43.9999H62.2241V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3315 9.60278H62.2246V43.9999H62.3315V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.437 9.60278H62.3301V43.9999H62.437V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5444 9.60278H62.4375V43.9999H62.5444V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6499 9.60278H62.543V43.9999H62.6499V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7573 9.60278H62.6504V43.9999H62.7573V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8628 9.60278H62.7559V43.9999H62.8628V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9682 9.60278H62.8613V43.9999H62.9682V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0737 9.60278H62.9668V43.9999H63.0737V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1811 9.60278H63.0742V43.9999H63.1811V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2866 9.60278H63.1797V43.9999H63.2866V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.394 9.60278H63.2871V43.9999H63.394V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4995 9.60278H63.3926V43.9999H63.4995V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6069 9.60278H63.5V43.9999H63.6069V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7124 9.60278H63.6055V43.9999H63.7124V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8198 9.60278H63.7129V43.9999H63.8198V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9253 9.60278H63.8184V43.9999H63.9253V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0307 9.60278H63.9238V43.9999H64.0307V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1362 9.60278H64.0293V43.9999H64.1362V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2436 9.60278H64.1367V43.9999H64.2436V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3491 9.60278H64.2422V43.9999H64.3491V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4565 9.60278H64.3496V43.9999H64.4565V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.562 9.60278H64.4551V43.9999H64.562V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6694 9.60278H64.5625V43.9999H64.6694V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7749 9.60278H64.668V43.9999H64.7749V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8803 9.60278H64.7734V43.9999H64.8803V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9858 9.60278H64.8789V43.9999H64.9858V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0932 9.60278H64.9863V43.9999H65.0932V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1987 9.60278H65.0918V43.9999H65.1987V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3061 9.60278H65.1992V43.9999H65.3061V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4135 9.60278H65.3066V43.9999H65.4135V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.519 9.60278H65.4121V43.9999H65.519V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6264 9.60278H65.5195V43.9999H65.6264V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7319 9.60278H65.625V43.9999H65.7319V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8393 9.60278H65.7324V43.9999H65.8393V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9448 9.60278H65.8379V43.9999H65.9448V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0503 9.60278H65.9434V43.9999H66.0503V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1557 9.60278H66.0488V43.9999H66.1557V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2631 9.60278H66.1562V43.9999H66.2631V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3686 9.60278H66.2617V43.9999H66.3686V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.476 9.60278H66.3691V43.9999H66.476V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5815 9.60278H66.4746V43.9999H66.5815V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6889 9.60278H66.582V43.9999H66.6889V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7944 9.60278H66.6875V43.9999H66.7944V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8999 9.60278H66.793V43.9999H66.8999V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0053 9.60278H66.8984V43.9999H67.0053V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1128 9.60278H67.0059V43.9999H67.1128V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2182 9.60278H67.1113V43.9999H67.2182V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3257 9.60278H67.2188V43.9999H67.3257V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4311 9.60278H67.3242V43.9999H67.4311V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5385 9.60278H67.4316V43.9999H67.5385V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.644 9.60278H67.5371V43.9999H67.644V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7514 9.60278H67.6445V43.9999H67.7514V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8569 9.60278H67.75V43.9999H67.8569V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9643 9.60278H67.8574V43.9999H67.9643V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0698 9.60278H67.9629V43.9999H68.0698V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1753 9.60278H68.0684V43.9999H68.1753V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2807 9.60278H68.1738V43.9999H68.2807V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3881 9.60278H68.2812V43.9999H68.3881V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4936 9.60278H68.3867V43.9999H68.4936V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.601 9.60278H68.4941V43.9999H68.601V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7085 9.60278H68.6016V43.9999H68.7085V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8139 9.60278H68.707V43.9999H68.8139V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9194 9.60278H68.8125V43.9999H68.9194V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0249 9.60278H68.918V43.9999H69.0249V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1323 9.60278H69.0254V43.9999H69.1323V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2378 9.60278H69.1309V43.9999H69.2378V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3452 9.60278H69.2383V43.9999H69.3452V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4507 9.60278H69.3438V43.9999H69.4507V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5581 9.60278H69.4512V43.9999H69.5581V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6635 9.60278H69.5566V43.9999H69.6635V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.771 9.60278H69.6641V43.9999H69.771V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8764 9.60278H69.7695V43.9999H69.8764V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9819 9.60278H69.875V43.9999H69.9819V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0874 9.60278H69.9805V43.9999H70.0874V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1948 9.60278H70.0879V43.9999H70.1948V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3003 9.60278H70.1934V43.9999H70.3003V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4077 9.60278H70.3008V43.9999H70.4077V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5131 9.60278H70.4062V43.9999H70.5131V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6206 9.60278H70.5137V43.9999H70.6206V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.726 9.60278H70.6191V43.9999H70.726V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8335 9.60278H70.7266V43.9999H70.8335V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9389 9.60278H70.832V43.9999H70.9389V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0444 9.60278H70.9375V43.9999H71.0444V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1499 9.60278H71.043V43.9999H71.1499V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2573 9.60278H71.1504V43.9999H71.2573V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3628 9.60278H71.2559V43.9999H71.3628V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4702 9.60278H71.3633V43.9999H71.4702V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5756 9.60278H71.4688V43.9999H71.5756V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6831 9.60278H71.5762V43.9999H71.6831V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7885 9.60278H71.6816V43.9999H71.7885V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.896 9.60278H71.7891V43.9999H71.896V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0014 9.60278H71.8945V43.9999H72.0014V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1069 9.60278H72V43.9999H72.1069V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2143 9.60278H72.1074V43.9999H72.2143V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3198 9.60278H72.2129V43.9999H72.3198V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4272 9.60278H72.3203V43.9999H72.4272V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5327 9.60278H72.4258V43.9999H72.5327V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6401 9.60278H72.5332V43.9999H72.6401V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7456 9.60278H72.6387V43.9999H72.7456V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.851 9.60278H72.7441V43.9999H72.851V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9565 9.60278H72.8496V43.9999H72.9565V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0639 9.60278H72.957V43.9999H73.0639V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1917 9.60278H73.0625V43.9999H73.1917V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3226 9.60278H73.1934V43.9999H73.3226V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4515 9.60278H73.3223V43.9999H73.4515V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5824 9.60278H73.4531V43.9999H73.5824V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7113 9.60278H73.582V43.9999H73.7113V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8402 9.60278H73.7109V43.9999H73.8402V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.971 9.60278H73.8418V43.9999H73.971V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0999 9.60278H73.9707V43.9999H74.0999V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2308 9.60278H74.1016V43.9999H74.2308V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3597 9.60278H74.2305V43.9999H74.3597V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4886 9.60278H74.3594V43.9999H74.4886V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6195 9.60278H74.4902V43.9999H74.6195V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7484 9.60278H74.6191V43.9999H74.7484V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8773 9.60278H74.748V43.9999H74.8773V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0081 9.60278H74.8789V43.9999H75.0081V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.139 9.60278H75.0098V43.9999H75.139V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2679 9.60278H75.1387V43.9999H75.2679V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3968 9.60278H75.2676V43.9999H75.3968V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5257 9.60278H75.3965V43.9999H75.5257V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6585 9.60278H75.5293V43.9999H75.6585V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7874 9.60278H75.6582V43.9999H75.7874V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9163 9.60278H75.7871V43.9999H75.9163V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0453 9.60278H75.916V43.9999H76.0453V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1761 9.60278H76.0469V43.9999H76.1761V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.305 9.60278H76.1758V43.9999H76.305V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4359 9.60278H76.3066V43.9999H76.4359V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5648 9.60278H76.4355V43.9999H76.5648V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6956 9.60278H76.5664V43.9999H76.6956V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8245 9.60278H76.6953V43.9999H76.8245V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9535 9.60278H76.8242V43.9999H76.9535V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0843 9.60278H76.9551V43.9999H77.0843V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2132 9.60278H77.084V43.9999H77.2132V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3421 9.60278H77.2129V43.9999H77.3421V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.473 9.60278H77.3438V43.9999H77.473V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6019 9.60278H77.4727V43.9999H77.6019V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7308 9.60278H77.6016V43.9999H77.7308V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8617 9.60278H77.7324V43.9999H77.8617V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9906 9.60278H77.8613V43.9999H77.9906V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1214 9.60278H77.9922V43.9999H78.1214V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2503 9.60278H78.1211V43.9999H78.2503V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3792 9.60278H78.25V43.9999H78.3792V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5082 9.60278H78.3789V43.9999H78.5082V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.641 9.60278H78.5117V43.9999H78.641V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7699 9.60278H78.6406V43.9999H78.7699V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8988 9.60278H78.7695V43.9999H78.8988V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0277 9.60278H78.8984V43.9999H79.0277V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1585 9.60278H79.0293V43.9999H79.1585V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2894 9.60278H79.1602V43.9999H79.2894V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4183 9.60278H79.2891V43.9999H79.4183V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5472 9.60278H79.418V43.9999H79.5472V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6781 9.60278H79.5488V43.9999H79.6781V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.807 9.60278H79.6777V43.9999H79.807V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9359 9.60278H79.8066V43.9999H79.9359V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0667 9.60278H79.9375V43.9999H80.0667V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1956 9.60278H80.0664V43.9999H80.1956V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3265 9.60278H80.1973V43.9999H80.3265V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4554 9.60278H80.3262V43.9999H80.4554V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5843 9.60278H80.4551V43.9999H80.5843V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7152 9.60278H80.5859V43.9999H80.7152V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8441 9.60278H80.7148V43.9999H80.8441V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9749 9.60278H80.8457V43.9999H80.9749V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1038 9.60278H80.9746V43.9999H81.1038V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2328 9.60278H81.1035V43.9999H81.2328V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3636 9.60278H81.2344V43.9999H81.3636V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4945 9.60278H81.3652V43.9999H81.4945V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6234 9.60278H81.4941V43.9999H81.6234V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7523 9.60278H81.623V43.9999H81.7523V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8812 9.60278H81.752V43.9999H81.8812V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.012 9.60278H81.8828V43.9999H82.012V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.141 9.60278H82.0117V43.9999H82.141V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2718 9.60278H82.1426V43.9999H82.2718V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4007 9.60278H82.2715V43.9999H82.4007V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5316 9.60278H82.4023V43.9999H82.5316V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6605 9.60278H82.5312V43.9999H82.6605V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7894 9.60278H82.6602V43.9999H82.7894V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9203 9.60278H82.791V43.9999H82.9203V9.60278Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1919 9.60278H82.9219V43.9999H83.1919V9.60278Z",
    fill: "#FEC00F"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3694 27.2711H49.811C49.6352 27.2711 49.5042 27.212 49.402 27.1145C49.3061 27.025 49.2406 26.9052 49.2166 26.7742C49.1927 26.6432 49.2055 26.4978 49.2885 26.3461C49.2885 26.3461 55.636 13.3541 56.6473 10.718C56.8326 10.2323 56.5115 9.74339 56.005 9.7402C54.2572 9.72901 50.6082 9.70505 49.1432 9.69706C49.1495 9.68907 49.1559 9.68108 49.1623 9.6731H49.0569H40.5383C39.9599 9.6731 39.2698 10.0597 39.0077 10.5326L36.6241 15.8512C36.3253 16.388 36.6193 16.8273 37.2775 16.8273H43.2543C43.4843 16.8193 43.6744 16.9344 43.7783 17.1069C43.8885 17.2906 43.9029 17.5367 43.7879 17.7444L35.1063 33.3437C34.7756 33.938 34.9913 34.4237 35.5856 34.4237H44.7896H53.8754C54.4537 34.4237 55.1439 34.0371 55.4059 33.5642L58.0196 28.2456C58.3184 27.7088 58.0244 27.2695 57.3662 27.2695L57.3694 27.2711Z",
    fill: "#FEC00F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2466_23735",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 9,
    width: 25,
    height: 26
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3694 27.2711H49.811C49.6352 27.2711 49.5042 27.212 49.402 27.1145C49.3061 27.025 49.2406 26.9052 49.2166 26.7742C49.1927 26.6432 49.2055 26.4978 49.2885 26.3461C49.2885 26.3461 55.636 13.3541 56.6473 10.718C56.8326 10.2323 56.5115 9.74339 56.005 9.7402C54.2572 9.72901 50.6082 9.70505 49.1432 9.69706C49.1495 9.68907 49.1559 9.68108 49.1623 9.6731H49.0569H40.5383C39.9599 9.6731 39.2698 10.0597 39.0077 10.5326L36.6241 15.8512C36.3253 16.388 36.6193 16.8273 37.2775 16.8273H43.2543C43.4843 16.8193 43.6744 16.9344 43.7783 17.1069C43.8885 17.2906 43.9029 17.5367 43.7879 17.7444L35.1063 33.3437C34.7756 33.938 34.9913 34.4237 35.5856 34.4237H44.7896H53.8754C54.4537 34.4237 55.1439 34.0371 55.4059 33.5642L58.0196 28.2456C58.3184 27.7088 58.0244 27.2695 57.3662 27.2695L57.3694 27.2711Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2466_23735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0269 9.67456H34.7793V34.4252H35.0269V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0672 9.67456H35.0273V34.4252H35.0672V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1082 9.67456H35.0684V34.4252H35.1082V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1473 9.67456H35.1074V34.4252H35.1473V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1883 9.67456H35.1484V34.4252H35.1883V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2293 9.67456H35.1895V34.4252H35.2293V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2684 9.67456H35.2285V34.4252H35.2684V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3094 9.67456H35.2695V34.4252H35.3094V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3504 9.67456H35.3105V34.4252H35.3504V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3895 9.67456H35.3496V34.4252H35.3895V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4305 9.67456H35.3906V34.4252H35.4305V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4715 9.67456H35.4316V34.4252H35.4715V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5125 9.67456H35.4727V34.4252H35.5125V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5516 9.67456H35.5117V34.4252H35.5516V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5946 9.67456H35.5547V34.4252H35.5946V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6336 9.67456H35.5938V34.4252H35.6336V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6727 9.67456H35.6328V34.4252H35.6727V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7137 9.67456H35.6738V34.4252H35.7137V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7547 9.67456H35.7148V34.4252H35.7547V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7957 9.67456H35.7559V34.4252H35.7957V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8348 9.67456H35.7949V34.4252H35.8348V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8758 9.67456H35.8359V34.4252H35.8758V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9168 9.67456H35.877V34.4252H35.9168V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9559 9.67456H35.916V34.4252H35.9559V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9989 9.67456H35.959V34.4252H35.9989V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0379 9.67456H35.998V34.4252H36.0379V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.077 9.67456H36.0371V34.4252H36.077V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.12 9.67456H36.0801V34.4252H36.12V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.159 9.67456H36.1191V34.4252H36.159V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2 9.67456H36.1602V34.4252H36.2V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2411 9.67456H36.2012V34.4252H36.2411V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2801 9.67456H36.2402V34.4252H36.2801V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3211 9.67456H36.2812V34.4252H36.3211V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3622 9.67456H36.3223V34.4252H36.3622V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4032 9.67456H36.3633V34.4252H36.4032V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4422 9.67456H36.4023V34.4252H36.4422V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4832 9.67456H36.4434V34.4252H36.4832V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5223 9.67456H36.4824V34.4252H36.5223V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5633 9.67456H36.5234V34.4252H36.5633V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6043 9.67456H36.5645V34.4252H36.6043V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6454 9.67456H36.6055V34.4252H36.6454V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6844 9.67456H36.6445V34.4252H36.6844V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7254 9.67456H36.6855V34.4252H36.7254V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7664 9.67456H36.7266V34.4252H36.7664V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8055 9.67456H36.7656V34.4252H36.8055V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8485 9.67456H36.8086V34.4252H36.8485V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8875 9.67456H36.8477V34.4252H36.8875V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9266 9.67456H36.8867V34.4252H36.9266V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9676 9.67456H36.9277V34.4252H36.9676V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0086 9.67456H36.9688V34.4252H37.0086V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0497 9.67456H37.0098V34.4252H37.0497V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0887 9.67456H37.0488V34.4252H37.0887V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1297 9.67456H37.0898V34.4252H37.1297V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1707 9.67456H37.1309V34.4252H37.1707V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2098 9.67456H37.1699V34.4252H37.2098V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2528 9.67456H37.2129V34.4252H37.2528V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2918 9.67456H37.252V34.4252H37.2918V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3309 9.67456H37.291V34.4252H37.3309V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3739 9.67456H37.334V34.4252H37.3739V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4129 9.67456H37.373V34.4252H37.4129V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4539 9.67456H37.4141V34.4252H37.4539V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.495 9.67456H37.4551V34.4252H37.495V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.534 9.67456H37.4941V34.4252H37.534V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.575 9.67456H37.5352V34.4252H37.575V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6161 9.67456H37.5762V34.4252H37.6161V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6551 9.67456H37.6152V34.4252H37.6551V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6961 9.67456H37.6562V34.4252H37.6961V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7372 9.67456H37.6973V34.4252H37.7372V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7782 9.67456H37.7383V34.4252H37.7782V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8172 9.67456H37.7773V34.4252H37.8172V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8582 9.67456H37.8184V34.4252H37.8582V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8993 9.67456H37.8594V34.4252H37.8993V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9383 9.67456H37.8984V34.4252H37.9383V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9813 9.67456H37.9414V34.4252H37.9813V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0204 9.67456H37.9805V34.4252H38.0204V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0594 9.67456H38.0195V34.4252H38.0594V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1024 9.67456H38.0625V34.4252H38.1024V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1414 9.67456H38.1016V34.4252H38.1414V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1825 9.67456H38.1426V34.4252H38.1825V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2235 9.67456H38.1836V34.4252H38.2235V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2625 9.67456H38.2227V34.4252H38.2625V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3036 9.67456H38.2637V34.4252H38.3036V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3426 9.67456H38.3027V34.4252H38.3426V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3856 9.67456H38.3457V34.4252H38.3856V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4247 9.67456H38.3848V34.4252H38.4247V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4637 9.67456H38.4238V34.4252H38.4637V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5067 9.67456H38.4668V34.4252H38.5067V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5457 9.67456H38.5059V34.4252H38.5457V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5868 9.67456H38.5469V34.4252H38.5868V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6278 9.67456H38.5879V34.4252H38.6278V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6668 9.67456H38.627V34.4252H38.6668V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7079 9.67456H38.668V34.4252H38.7079V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7489 9.67456H38.709V34.4252H38.7489V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7899 9.67456H38.75V34.4252H38.7899V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8289 9.67456H38.7891V34.4252H38.8289V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.87 9.67456H38.8301V34.4252H38.87V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.911 9.67456H38.8711V34.4252H38.911V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.95 9.67456H38.9102V34.4252H38.95V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9911 9.67456H38.9512V34.4252H38.9911V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0321 9.67456H38.9922V34.4252H39.0321V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0711 9.67456H39.0312V34.4252H39.0711V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1141 9.67456H39.0742V34.4252H39.1141V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1532 9.67456H39.1133V34.4252H39.1532V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1922 9.67456H39.1523V34.4252H39.1922V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2352 9.67456H39.1953V34.4252H39.2352V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2743 9.67456H39.2344V34.4252H39.2743V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3153 9.67456H39.2754V34.4252H39.3153V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3563 9.67456H39.3164V34.4252H39.3563V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3954 9.67456H39.3555V34.4252H39.3954V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4364 9.67456H39.3965V34.4252H39.4364V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4774 9.67456H39.4375V34.4252H39.4774V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5184 9.67456H39.4785V34.4252H39.5184V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5575 9.67456H39.5176V34.4252H39.5575V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5965 9.67456H39.5566V34.4252H39.5965V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6395 9.67456H39.5996V34.4252H39.6395V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6786 9.67456H39.6387V34.4252H39.6786V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7196 9.67456H39.6797V34.4252H39.7196V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7606 9.67456H39.7207V34.4252H39.7606V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7997 9.67456H39.7598V34.4252H39.7997V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8407 9.67456H39.8008V34.4252H39.8407V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8817 9.67456H39.8418V34.4252H39.8817V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9227 9.67456H39.8828V34.4252H39.9227V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9618 9.67456H39.9219V34.4252H39.9618V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0028 9.67456H39.9629V34.4252H40.0028V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0418 9.67456H40.002V34.4252H40.0418V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0829 9.67456H40.043V34.4252H40.0829V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1239 9.67456H40.084V34.4252H40.1239V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1649 9.67456H40.125V34.4252H40.1649V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2039 9.67456H40.1641V34.4252H40.2039V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.245 9.67456H40.2051V34.4252H40.245V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.286 9.67456H40.2461V34.4252H40.286V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.325 9.67456H40.2852V34.4252H40.325V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.368 9.67456H40.3281V34.4252H40.368V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4071 9.67456H40.3672V34.4252H40.4071V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4461 9.67456H40.4062V34.4252H40.4461V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4891 9.67456H40.4492V34.4252H40.4891V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5282 9.67456H40.4883V34.4252H40.5282V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5692 9.67456H40.5293V34.4252H40.5692V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6102 9.67456H40.5703V34.4252H40.6102V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6493 9.67456H40.6094V34.4252H40.6493V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6903 9.67456H40.6504V34.4252H40.6903V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7313 9.67456H40.6914V34.4252H40.7313V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7723 9.67456H40.7324V34.4252H40.7723V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8114 9.67456H40.7715V34.4252H40.8114V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8524 9.67456H40.8125V34.4252H40.8524V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.034 9.67456H40.8535V34.4252H41.034V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2118 9.67456H41.0312V34.4252H41.2118V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3934 9.67456H41.2129V34.4252H41.3934V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5731 9.67456H41.3926V34.4252H41.5731V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7528 9.67456H41.5723V34.4252H41.7528V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9305 9.67456H41.75V34.4252H41.9305V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1122 9.67456H41.9316V34.4252H42.1122V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2899 9.67456H42.1094V34.4252H42.2899V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4715 9.67456H42.291V34.4252H42.4715V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6512 9.67456H42.4707V34.4252H42.6512V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8309 9.67456H42.6504V34.4252H42.8309V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0106 9.67456H42.8301V34.4252H43.0106V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1903 9.67456H43.0098V34.4252H43.1903V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.37 9.67456H43.1895V34.4252H43.37V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5497 9.67456H43.3691V34.4252H43.5497V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7294 9.67456H43.5488V34.4252H43.7294V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.909 9.67456H43.7285V34.4252H43.909V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0887 9.67456H43.9082V34.4252H44.0887V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2684 9.67456H44.0879V34.4252H44.2684V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4481 9.67456H44.2676V34.4252H44.4481V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6278 9.67456H44.4473V34.4252H44.6278V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8075 9.67456H44.627V34.4252H44.8075V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9872 9.67456H44.8066V34.4252H44.9872V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1669 9.67456H44.9863V34.4252H45.1669V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3465 9.67456H45.166V34.4252H45.3465V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5262 9.67456H45.3457V34.4252H45.5262V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7059 9.67456H45.5254V34.4252H45.7059V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8856 9.67456H45.7051V34.4252H45.8856V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0653 9.67456H45.8848V34.4252H46.0653V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.245 9.67456H46.0645V34.4252H46.245V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4247 9.67456H46.2441V34.4252H46.4247V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6044 9.67456H46.4238V34.4252H46.6044V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.786 9.67456H46.6055V34.4252H46.786V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9637 9.67456H46.7832V34.4252H46.9637V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1434 9.67456H46.9629V34.4252H47.1434V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3231 9.67456H47.1426V34.4252H47.3231V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5048 9.67456H47.3242V34.4252H47.5048V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6825 9.67456H47.502V34.4252H47.6825V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8641 9.67456H47.6836V34.4252H47.8641V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0419 9.67456H47.8613V34.4252H48.0419V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2235 9.67456H48.043V34.4252H48.2235V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4012 9.67456H48.2207V34.4252H48.4012V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5829 9.67456H48.4023V34.4252H48.5829V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7606 9.67456H48.5801V34.4252H48.7606V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9423 9.67456H48.7617V34.4252H48.9423V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1219 9.67456H48.9414V34.4252H49.1219V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3016 9.67456H49.1211V34.4252H49.3016V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4794 9.67456H49.2988V34.4252H49.4794V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.661 9.67456H49.4805V34.4252H49.661V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8407 9.67456H49.6602V34.4252H49.8407V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0204 9.67456H49.8398V34.4252H50.0204V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2001 9.67456H50.0195V34.4252H50.2001V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3798 9.67456H50.1992V34.4252H50.3798V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5575 9.67456H50.377V34.4252H50.5575V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7391 9.67456H50.5586V34.4252H50.7391V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9188 9.67456H50.7383V34.4252H50.9188V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0985 9.67456H50.918V34.4252H51.0985V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2782 9.67456H51.0977V34.4252H51.2782V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4579 9.67456H51.2773V34.4252H51.4579V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6376 9.67456H51.457V34.4252H51.6376V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8173 9.67456H51.6367V34.4252H51.8173V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9969 9.67456H51.8164V34.4252H51.9969V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1766 9.67456H51.9961V34.4252H52.1766V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3563 9.67456H52.1758V34.4252H52.3563V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.536 9.67456H52.3555V34.4252H52.536V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7157 9.67456H52.5352V34.4252H52.7157V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8954 9.67456H52.7148V34.4252H52.8954V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0751 9.67456H52.8945V34.4252H53.0751V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2548 9.67456H53.0742V34.4252H53.2548V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4344 9.67456H53.2539V34.4252H53.4344V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6141 9.67456H53.4336V34.4252H53.6141V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7938 9.67456H53.6133V34.4252H53.7938V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9755 9.67456H53.7949V34.4252H53.9755V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1532 9.67456H53.9727V34.4252H54.1532V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3348 9.67456H54.1543V34.4252H54.3348V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5126 9.67456H54.332V34.4252H54.5126V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9415 9.67456H54.5117V34.4252H54.9415V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3731 9.67456H54.9434V34.4252H55.3731V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8048 9.67456H55.375V34.4252H55.8048V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2344 9.67456H55.8047V34.4252H56.2344V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6641 9.67456H56.2344V34.4252H56.6641V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0938 9.67456H56.6641V34.4252H57.0938V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5255 9.67456H57.0957V34.4252H57.5255V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9552 9.67456H57.5254V34.4252H57.9552V9.67456Z",
    fill: "#FEC00F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3229 9.67456H57.957V34.4252H58.3229V9.67456Z",
    fill: "#FEC00F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVzyLogo);
export default __webpack_public_path__ + "static/media/vzy-logo.68d681fd923cad514e8ae73847eba487.svg";
export { ForwardRef as ReactComponent };